module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAQAAACI04Q8AAAA+klEQVQoz4XRvUoDARAE4CGiAZtUlhJfQCvFJkVEwcpW7CQI9laxtfEJ4juIiETEA7EOws5cAka0sDRdcqCQI3hE1uL8C2qOrXb52IVZaJ8xfUzFqiKDOJ0xuGPDccSG2gavwl0m/6Ik3NQk6HwI9zj4kwxs426K56DT2dMh+79I39aCvC7o+FyrI76MkGeVHvO6pH+j6+aMLVn0RXrNRUBnaQc633RwMsEyEC6oQ6dbR/OArarEKEXdcF3TPKaz5jkVrGIVFTzHGp2nWuYTHTZ7M8fWx5GgUQSARpFBOtFtq6x7aIXdn7mwzfZIbhG3oNfMtyRgPRPV3wE3AZNT92pbUgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeImg/home_dibu_icon_youxiang@2x.png
// module id = /is6
// module chunks = 0